import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useFetcher from "@/utils/use-fetcher";
import { AxiosRequestConfig } from "axios";

export interface ReviewLineSheetProductImageRequest {
  reviewStatus: string;
}

export interface ReviewLineSheetProductImageResponse {}

export interface ReviewLineSheetProductImagePathParameter {
  lineSheetProductImageId: number;
}

export const reviewLineSheetProductImageTemplateUrl = `/product/images/:lineSheetProductImageId/review`;

export const reviewLineSheetProductImageKey: YWRKey<ReviewLineSheetProductImagePathParameter> =
  {
    url: (parameter) => {
      return calcUrl(reviewLineSheetProductImageTemplateUrl, parameter);
    },
    method: "put",
  };

export default function useReviewLineSheetProductImage(
  config?: AxiosRequestConfig<ReviewLineSheetProductImageRequest>
) {
  const fetcher = useFetcher<
    ReviewLineSheetProductImageRequest,
    ReviewLineSheetProductImageResponse
  >();
  return useYWR(reviewLineSheetProductImageKey, fetcher, {
    ...config,
    timeout: 3 * 60 * 1000,
  });
}
